export const EMBEDS_ROUTE = {
  name: 'Embeds',
  path: 'embeds',
};
